import { createApp } from 'vue'
import axios from 'axios'
import swal from 'sweetalert'
import PhoneInput from './components/PhoneInput'

// Stripe
const stripe = Stripe(window.pawine.stripeKey)
let elements

window.pawine = window.pawine || {}

const app = createApp({
  components: { 'phone-input': PhoneInput },
  data() {
    return {
      routes: window.pawine.routes || [],
      wineries: window.pawine.wineries || [],
      isProcessing: false,
      currentStep: 'registration-type', // "registration-type" or "payment"
      registrationCost: null,
      registrationType: 'new-member',
      wineryId: '',
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      password: null,
      passwordConfirmation: null,
    }
  },
  computed: {
    selectedWinery() {
      return this.wineries.find(winery => winery.id == this.wineryId)
    },
    registrationTypeLabel() {
      if (this.registrationType == 'new-member') {
        return 'New Member Registration'
      }

      if (this.registrationType == 'renewal') {
        return 'Renewal'
      }
    }
  },
  methods: {
    progressToPaymentStep() {
      if (! this.wineryId) {
        swal('', 'Please select your winery.')
        return
      }

      this.currentStep = 'payment'

      this.initializeStripe()
    },
    returnToRegistrationTypeStep() {
      this.currentStep = 'registration-type'
      this.registrationCost = null
    },
    // Fetches a payment intent and captures the client secret and cost.
    async initializeStripe() {
      const resp = await axios.post(this.routes.createPaymentIntent, {
        registrationType: this.registrationType,
        headers: { 'Content-Type': 'application/json' },
      })

      if (! resp.data.registrationCost) {
        swal('', 'An unexpected error occurred.', 'error')
        return
      }

      // Set the cost.
      this.registrationCost = resp.data.registrationCost

      // Setup Stripe payment Elements.
      elements = stripe.elements({ clientSecret: resp.data.clientSecret })
      const paymentElement = elements.create('payment', {
        layout: 'tabs',
      })
      paymentElement.mount('#payment-element')
    },
    // Handle the form submission.
    async handleSubmit() {

      this.isProcessing = true

      // Create a pending registration.
      let registrationUuid

      try {
        const resp = await axios.post(this.routes.register, {
          registration_type: this.registrationType,
          winery_id: this.wineryId,
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
        })

        // The pending user registration's UUID.
        registrationUuid = resp.data.uuid
        if (! registrationUuid) {
          throw new Error('An unexpected error occurred. Please try again.')
        }

      } catch (error) {
        this.isProcessing = false

        console.error(error)

        if (error.response && error.response.data && error.response.data.errors) {
          let errors = []
          for (let e in error.response.data.errors) {
            errors.push(error.response.data.errors[e][0])
          }

          let div = document.createElement('div');
          div.innerHTML = '<ul class="alert alert-danger text-start"><li>' + errors.join('</li><li>') + '</li></ul>'
          swal({
            content: div
          })
        } else {
          swal('An unexpected error occurred.')
        }

        return
      }

      // Process the payment.
      const { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: this.routes.stripeReturnUrl + '?uuid=' + registrationUuid,
        },
      })

      // This point will only be reached if there is an immediate error when
      // confirming the payment. Otherwise, your customer will be redirected to
      // your `return_url`. For some payment methods like iDEAL, your customer will
      // be redirected to an intermediate site first to authorize the payment, then
      // redirected to the `return_url`.
      let div = document.createElement('div')

      if (error.type === 'card_error' || error.type === 'validation_error') {
        div.innerHTML = error.message
      } else {
        div.innerHTML = 'An unexpected error occurred.'
      }

      swal({
        content: div
      })

      this.isProcessing = false
    },
  }
}).mount('#registration-form')
